/**
 * 計算フィールド 計算エンジン（#3145）のフィールドコード変更時の式書き換え。
 * フィールドコードを変更したとき、参照している式を自動で追随させる（設計書 §5.2）。
 * ⚠️ functions/src/utils/calculation と main/src/utils/calculation は同一内容。
 *    片方だけ変更しないこと（変更時は両方へ反映し、共通テストで一致を確認する）。
 */
import { tokenize } from './tokenizer';

/**
 * 式の中の {oldCode} 参照を {newCode} に書き換える。
 * トークン単位で置換するため、文字列リテラル内の波括弧は書き換えない。
 * トークン化できない式は書き換えず元のまま返す
 */
export const renameFieldCodeInFormula = (
  formula: string,
  oldCode: string,
  newCode: string,
): string => {
  let result = '';
  let cursor = 0;
  try {
    tokenize(formula).forEach(token => {
      if (token.type === 'fieldRef' && token.value === oldCode) {
        result += formula.slice(cursor, token.position) + `{${newCode}}`;
        cursor = token.end;
      }
    });
  } catch {
    return formula;
  }
  return result + formula.slice(cursor);
};
